import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Popover from '@mui/material/Popover'
import Typography from '@mui/material/Typography'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import Button from '@mui/material/Button'
import LoaderComponent from '../loaderComp/LoaderComponent'
import ModalComponent from '../ModalComponent/ModalComponent'
import TableComponent from '../tableComponent/TableComponent'
import { deletereport, reportHistoryService } from '../services/fetchreport'
import { updateReportsData } from '../reduxstore/actions'
import '../tableComponent/Table.scss'

export default function PopoverComponent(props: any) {
  const dispatch = useDispatch()
  const [ele, setEle] = useState<any>(null)
  const [modalOpen, setModal] = useState(false)
  const [hasError, setError] = useState(false)
  const [ModalType, setModalType] = useState('')
  const [isloading, setLoading] = useState(false)
  const [isDelete, setDelete] = useState(false)
  const [modalContent, setModalContent] = useState<any>({
    deleteContent: {
      headerTitle: 'Message',
      bodyContent: 'Report is deleted successfully',
      bodyErrorContent: 'Unable to delete report. Please try again'
    },
    reportHistory: {
      headerTitle: 'Report History',
      bodyErrorContent: 'Unable to retrieve history of reports. please try again'
    }
  })

  const handleClick = (event: any) => {
    setEle(event.currentTarget)
  }

  const handleClose = () => {
    setEle(null)
  }

  const handleModalClose = () => {
    setModal(false)
  }

  const reportList = useSelector((state: any) => state.reducers.reports)
  const userData = useSelector((state: any) => state.reducers.userInfo)

  const handleHistory = async (e: any) => {
    setLoading(true)
    setModalType('reportHistory')
    let report: any = ''
    const reportId = (e.target.parentElement.dataset.index ?? e.target.dataset.index)
    const userTypeName = props.userTypeName
    if (reportId) {
      report = reportList.filter((reportItem: any) => ((reportItem.reportId === reportId || reportItem.reportName === reportId || reportItem.customerName === reportId)) && (reportItem.userTypeName === userTypeName))
    }
    const userDetails: any = {
      customerName: [ 'string' ],
      reportName: report[0].reportName,
      reportNameDt: '',
      reportId: report[0].reportId,
      userRole: 'string',
      userType: report[0].userTypeName ? report[0].userTypeName : userData[0].userType,
      username: userData[0].userName,
      userEmailAddr: userData[0].userEmailAddr,
      encUserType: userData[0].encUserType,
      encUserName: userData[0].encUserName,
      encUserEmailAddr: userData[0].encUserEmailAddr,
      e_id: userData[0].e_id

    }
    let reportHistoryData: any[] = []
    let historyError = false
    try {
//       const res: any[] = [ {
//   "cust_file_id" : "i373C17B791794835BD6C5E43F3B93BC3",
//   "customerName" : "WESTERN DIGITAL TECHNOLOGIES - 215214",
//   "reportFrequency" : "Daily",
//   "reportGenDate" : "2025-08-22 04:35",
//   "reportName" : "DISDAI7935: Western Digital Daily Change LTD Report",
//   "reportNameDt" : "DISDAI7935: Western Digital Daily Change LTD Report 08-22-2025",
//   "userTypeName" : "cognos",
//   "bookmarkStatus" : null,
//   "reportTypeDesc" : "Claim Status and Activity",
//   "reportCategoryDesc" : "Absence Management Reports",
//   "enc_file_id" : "sqpLm+08t+u5zRLN9LK/ulcvYQ0PqSEpKwK1Hz9CBLo29NB1wT6N+CJMEyd3Jtjx",
//   "reportId" : null,
//   "enc_customerName" : null,
//   "enc_userTypeName" : null,
//   "enc_reportFrequency" : null,
//   "enc_reportGenDate" : null,
//   "enc_reportName" : null,
//   "enc_reportNameDt" : null,
//   "enc_reportTypeDesc" : null,
//   "enc_reportCategoryDesc" : null
// }, {
//   "cust_file_id" : "iD73DF8F792E3438987BF3300656884D0",
//   "customerName" : "WESTERN DIGITAL TECHNOLOGIES - 215214",
//   "reportFrequency" : "Daily",
//   "reportGenDate" : "2025-08-21 04:48",
//   "reportName" : "DISDAI7935: Western Digital Daily Change LTD Report",
//   "reportNameDt" : "DISDAI7935: Western Digital Daily Change LTD Report 08-21-2025",
//   "userTypeName" : "cognos",
//   "bookmarkStatus" : null,
//   "reportTypeDesc" : "Claim Status and Activity",
//   "reportCategoryDesc" : "Absence Management Reports",
//   "enc_file_id" : "lUyP1hVQD+Tgun1gxX0RbaeS2wie4S2Q/l0wrtPvOHdC+VyjuWxUPsY9creJP8yq",
//   "reportId" : null,
//   "enc_customerName" : null,
//   "enc_userTypeName" : null,
//   "enc_reportFrequency" : null,
//   "enc_reportGenDate" : null,
//   "enc_reportName" : null,
//   "enc_reportNameDt" : null,
//   "enc_reportTypeDesc" : null,
//   "enc_reportCategoryDesc" : null
// }, {
//   "cust_file_id" : "iEABAD88FF551445797609ACE48ABE08D",
//   "customerName" : "WESTERN DIGITAL TECHNOLOGIES - 215214",
//   "reportFrequency" : "Daily",
//   "reportGenDate" : "2025-08-20 04:59",
//   "reportName" : "DISDAI7935: Western Digital Daily Change LTD Report",
//   "reportNameDt" : "DISDAI7935: Western Digital Daily Change LTD Report 08-20-2025",
//   "userTypeName" : "cognos",
//   "bookmarkStatus" : null,
//   "reportTypeDesc" : "Claim Status and Activity",
//   "reportCategoryDesc" : "Absence Management Reports",
//   "enc_file_id" : "VNVSKK6V37gsupi7Jup4JYvrsvWHWvRre34gvx3Oy3am7HuO2nlQJSI3ov/5LMK2",
//   "reportId" : null,
//   "enc_customerName" : null,
//   "enc_userTypeName" : null,
//   "enc_reportFrequency" : null,
//   "enc_reportGenDate" : null,
//   "enc_reportName" : null,
//   "enc_reportNameDt" : null,
//   "enc_reportTypeDesc" : null,
//   "enc_reportCategoryDesc" : null
// }, {
//   "cust_file_id" : "iFD6A6114E6DA406391289AE6DFE830A2",
//   "customerName" : "WESTERN DIGITAL TECHNOLOGIES - 215214",
//   "reportFrequency" : "Daily",
//   "reportGenDate" : "2025-08-19 05:09",
//   "reportName" : "DISDAI7935: Western Digital Daily Change LTD Report",
//   "reportNameDt" : "DISDAI7935: Western Digital Daily Change LTD Report 08-19-2025",
//   "userTypeName" : "cognos",
//   "bookmarkStatus" : null,
//   "reportTypeDesc" : "Claim Status and Activity",
//   "reportCategoryDesc" : "Absence Management Reports",
//   "enc_file_id" : "/6oaS9Ousbo5WcU1aEN9lYB4x8tMj+6xgjD/IJNYFSXwG+2wkoWKdchCDFCvjlJF",
//   "reportId" : null,
//   "enc_customerName" : null,
//   "enc_userTypeName" : null,
//   "enc_reportFrequency" : null,
//   "enc_reportGenDate" : null,
//   "enc_reportName" : null,
//   "enc_reportNameDt" : null,
//   "enc_reportTypeDesc" : null,
//   "enc_reportCategoryDesc" : null
// }, {
//   "cust_file_id" : "iE36D07B3748F4E309A650F84B9E49C2A",
//   "customerName" : "WESTERN DIGITAL TECHNOLOGIES - 215214",
//   "reportFrequency" : "Daily",
//   "reportGenDate" : "2025-08-18 05:45",
//   "reportName" : "DISDAI7935: Western Digital Daily Change LTD Report",
//   "reportNameDt" : "DISDAI7935: Western Digital Daily Change LTD Report 08-18-2025",
//   "userTypeName" : "cognos",
//   "bookmarkStatus" : null,
//   "reportTypeDesc" : "Claim Status and Activity",
//   "reportCategoryDesc" : "Absence Management Reports",
//   "enc_file_id" : "RMLGGbxZb6RqeiBxvmCzBslTneXgBkw61tv44SUkrmS+0Ilv0LUr6zxYfvXZV3O0",
//   "reportId" : null,
//   "enc_customerName" : null,
//   "enc_userTypeName" : null,
//   "enc_reportFrequency" : null,
//   "enc_reportGenDate" : null,
//   "enc_reportName" : null,
//   "enc_reportNameDt" : null,
//   "enc_reportTypeDesc" : null,
//   "enc_reportCategoryDesc" : null
// } ]
 
      const res: any[] = await reportHistoryService(userDetails) // TODO: restore -> await reportHistoryService(userDetails)
      if ((res as any)?.status === 404 || (res as any)?.status === 400) {
        historyError = true
      } else if ((res as any)?.ok !== undefined && !(res as any).ok) {
        historyError = true
      } else {
        reportHistoryData = Array.isArray(res) ? res : Array.isArray((res as any)?.response) ? (res as any).response : Array.isArray((res as any)?.data) ? (res as any).data : []
      }
    } catch {
      historyError = true
    }

    const modifiedreports: any[] = []
    if (!historyError) {
      reportHistoryData.map((rep: any) => {
        const record: any = {}
        record.id = rep.cust_file_id || rep.cust_file_int_id
        if (props.isInternal) {
          record.customerName = rep.customerName
        }
        record.reportName = rep.reportNameDt
        record.frequency = rep.reportFrequency
        record.generatedDate = rep.reportGenDate
        record.userType = rep.userTypeName
        record.action = 'download'
        modifiedreports.push(record)
        return rep
      })
      modifiedreports.sort((report1, report2) => {
        return Date.parse(report2.generatedDate) - Date.parse(report1.generatedDate)
      })
    }

    const bodyContent = !historyError && modifiedreports.length > 0
      ? <TableComponent data={modifiedreports} columnNames={Object.keys(modifiedreports[0])} class={props.isInternal ? 'reporthistory-table' : 'reporthistory-external-table'} rowperpage={5} em={userDetails.encUserEmailAddr} e_id={userDetails.e_id}/>
      : <p className={'no-records-text'}>No Report History Found</p>

    setError(historyError)
    setModalContent({ ...modalContent, reportHistory: { headerTitle: `Report History - ${report[0].reportName}`, bodyContent, bodyErrorContent: 'Unable to retrieve history of reports. Please try again' } })
    setLoading(false)
    setModal(true)
    setEle(null)
    setDelete(false)
  }

  const open = Boolean(ele)
  const id = open ? 'simple-popover' : undefined

  const reportsgen = useSelector((state: any) => state.reducers.genreports)

  const handleDelete = async (e: any) => {
    const rptToDelete = e.target.parentElement.dataset.index ?? e.target.dataset.index
    const delrep = rptToDelete ? reportsgen.filter((rep: any) => rep.reportName === rptToDelete) : {}
    const report: any = {
      cust_file_id: delrep[0].cust_file_id,
      customerName: delrep[0].customerName,
      reportFrequency: delrep[0].reportFrequency,
      reportGenDate: delrep[0].reportGenDate,
      reportName: delrep[0].reportName,
      reportNameDt: delrep[0].reportNameDt,
      reportTypeDesc: delrep[0].reportTypeDesc,
      userTypeName: delrep[0].userTypeName,
      enc_file_id: delrep[0].enc_file_id,
      enc_customerName: delrep[0].enc_customerName,
      enc_userTypeName: delrep[0].enc_userTypeName,
      enc_reportFrequency: delrep[0].enc_reportFrequency,
      enc_reportGenDate: delrep[0].enc_reportGenDate,
      enc_reportName: delrep[0].enc_reportName,
      enc_reportNameDt: delrep[0].enc_reportNameDt,
      enc_reportTypeDesc: delrep[0].enc_reportTypeDesc
    }

    const onSoftDelete = await deletereport(report, props.userData[0].encUserEmailAddr, props.userData[0].e_id, props.userData[0].userEmailAddr)
    if (onSoftDelete.status) {
      setModalType('deleteContent')
      setModal(true)
      setError(true)
      setEle(null)
      setDelete(true)
    } else {
      setEle(null)
      setDelete(true)
      const filteredRecords: any[] = []
      onSoftDelete.map((rep: any) => {
        const record: any = {}
        record.id = rep.cust_file_id || rep.cust_file_int_id
        if (props.isInternal) {
          record.customerName = rep.customerName ? rep.customerName : ''
        }
        record.frequency = rep.reportFrequency ? rep.reportFrequency : ''
        record.reportName = rep.reportName ? rep.reportName : ''
        record.updatedDate = rep.reportGenDate ? rep.reportGenDate : ''
        record.reportType = rep.reportTypeDesc ? rep.reportTypeDesc : ''
        record.action = 'default'
        record.userTypeName = rep.userTypeName ? rep.userTypeName : ''
        filteredRecords.push(record)
        return rep
      })
      dispatch(updateReportsData(filteredRecords))
    }
  }

  return (
        <>
        {isloading && <LoaderComponent />}
            <Button onClick={handleClick}>
                <MoreVertIcon className={'action-link'} />
            </Button>
            <Popover
                id={id}
                open={open}
                anchorEl={ele}
                onClose={handleClose}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'center'
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'center'
                }}
            >
                <Typography >
                    <button className={'view-history'} data-index={props.index} onClick={(e) => handleHistory(e)}>Download Reports</button>
                    { props.isAdmin && <button className={'delete-record'} data-index={props.index} onClick={handleDelete}>Delete</button> }
                </Typography>
            </Popover>
            {modalOpen && <ModalComponent isOpen={modalOpen} isDelete={isDelete}onClose={handleModalClose} title={modalContent[ModalType].headerTitle}>
              {hasError ? modalContent[ModalType].bodyErrorContent : modalContent[ModalType].bodyContent}
              </ModalComponent>
              }
        </>
  )
}
